import api from "@/services/api";
import { ContentTemplate, ContentTemplateSizesDtoOut, PostsUsingContentTemplate, ExportModel } from "./types";

export async function getContentTemplates(): Promise<Array<ContentTemplate>> {
    return new Promise((resolve, reject) => {
        api.get("/contentTemplate").then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function getContentTemplatesByType(type: string): Promise<Array<ContentTemplate>> {
    return new Promise((resolve, reject) => {
        api.get(`/contentTemplate/type/${type}`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function getAllContentTemplateSizes(): Promise<Array<ContentTemplateSizesDtoOut>> {
    return new Promise((resolve, reject) => {
        api.get("/contentTemplate/sizes").then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function getContentTemplatesBySize(width: number, height: number, compareAspectRatio: boolean, aspectRatio: number): Promise<Array<ContentTemplate>> {
    return new Promise((resolve, reject) => {
        api.get(`/contentTemplate/${width}/${height}/${compareAspectRatio}/${aspectRatio}`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function getContentTemplate(id: string): Promise<ContentTemplate> {
    return new Promise((resolve, reject) => {
        api.get(`/contentTemplate/${id}`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function getContentTemplateWithoutAclCheck(id: string): Promise<ContentTemplate> {
    return new Promise((resolve, reject) => {
        api.get(`/contentTemplate/getWithoutAclCheck/${id}`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function checkDelete(id: string): Promise<PostsUsingContentTemplate[]> {
    return new Promise((resolve, reject) => {
        api.get(`/contentTemplate/checkdelete/${id}`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function deleteContentTemplate(id: string): Promise<void> {
    return new Promise((resolve, reject) => {
        api.delete(`/contentTemplate/${id}`).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function createContentTemplate(model: ContentTemplate): Promise<string> {
    return new Promise((resolve, reject) => {
        api.post("/contentTemplate", model).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function updateContentTemplate(model: ContentTemplate): Promise<void> {
    return new Promise((resolve, reject) => {
        api.put("/contentTemplate", model).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function copyContentTemplate(id: string, name: string): Promise<void> {
    return new Promise((resolve, reject) => {
        api.post("/contentTemplate/copy", { id: id, name: name }).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function swapOrder(itemOrder: any): Promise<void> {
    return new Promise((resolve, reject) => {
        api.post("/contentTemplate/swap/", itemOrder).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function exportTemplates(model: ExportModel): Promise<string> {
    return new Promise((resolve, reject) => {
        api.postDownloadFile("/contentTemplate/export", model).then(
            response => {
                const url = window.URL.createObjectURL(new Blob([response.data], { type: response.headers["content-type"] }));
                const link = document.createElement("a");
                link.href = url;
                link.download = response.headers.filename;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}

export async function importTemplates(model: FormData): Promise<void> {
    return new Promise((resolve, reject) => {
        api.post("/contentTemplate/import", model).then(
            response => {
                resolve(response.data);
            },
            error => {
                reject(error);
            }
        );
    });
}
